module.exports = __webpack_public_path__ + "img/cateicon0_a.f082e30b.svg";